import styled from 'styled-components';

export const TaxesLabel = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};

  @media (max-width: 767px) {
    justify-content: flex-end;
  }

  img {
    filter: invert(55%) sepia(6%) saturate(247%) hue-rotate(201deg) brightness(99%) contrast(90%);
    margin-left: 2px;
    width: 14px;
    height: 14px;
  }
`;
